import { createAction } from '@reduxjs/toolkit';
import { IEntityReducer } from 'core/reducers/entities';
import { IRegisterReducer } from 'core/slices/register';
import { ISessionReducer } from 'core/slices/session';
import { EntityTypes } from '../../../constants/entities';
import { IQueue } from 'core/slices/queue';

export interface IUpdateState {
  id?: number;
  type: EntityTypes;
  culprit?: any;
}

export const updateState = createAction('state/update', function prepare(entity: IUpdateState) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const restoreState = createAction('state/restore', function prepare(updates: IUpdateState[]) {
  return {
    payload: updates,
  };
});

export interface IStart {
  id?: number;
  type: EntityTypes;
  isContinue?: boolean;
  preview?: boolean;
  moduleId?: number;
  auto: boolean;
}

export const start = createAction('start', function prepare(entity: IStart) {
  return {
    payload: {
      ...entity,
    },
  };
});

export interface IHydrate {
  prodEnt: IEntityReducer;
  session: ISessionReducer;
  register: IRegisterReducer;
  queue: IQueue;
  offlineId: number;
  stateSlice: Partial<Record<string, number | string>>;
}

export const hydrate = createAction('hydrate', function prepare(entity: Partial<IHydrate>) {
  return {
    payload: entity,
  };
});

export interface IPersist {
  prodEnt: boolean;
  session: boolean;
  register: boolean;
}

export const persist = createAction('persist', function prepare(entity: Partial<IPersist>) {
  return {
    payload: entity,
  };
});

export interface ISwitchUser {
  /** The organisation user the server just resolved this device to. */
  organisationUserId: number;
  /** The action that carried the new identity — for diagnostics. */
  source: string;
  /**
   * True when that action also carries a player response, i.e. the server has
   * already sent the new user's queue and nothing needs to re-request it.
   */
  carriesQueue: boolean;
}

/**
 * A different organisation user is now driving this device.
 *
 * Dispatched by `userScopeMiddleware` immediately *before* the response that
 * carried the new identity reaches the reducers, so every slice that caches
 * per-user data (the queue, the register, the player position, the session's
 * token/attempt/variable maps) drops the previous user's copy and the incoming
 * response lands on a clean slate.
 */
export const switchUser = createAction('user/switch', function prepare(payload: ISwitchUser) {
  return { payload };
});
